export default "https://cdn-static.gokick.com/assets/d8950a20925d8040d2b2bc8b449b43040bc9b501/images/tangerine-flavor.f6541269ddee78b301b9a4e8b180b6f6.png";